<div class="footer">
  <div class="navbar navbar-inverse footer-custom">
    <div [innerHTML]="footerHTML"></div>
  </div>
</div>
